import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { VonMessageService } from '@von-development-studio/primeng-message-service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { AdminCatalogModel } from 'src/app/model/admin/catalog';
import { adminCatalogActions } from 'src/app/store/admin/catalog/admin-catalog.action';
import { environment } from 'src/environments/environment';
import { CATALOG_CONSTANTS } from './admin-catalog.constants';

@Injectable({
  providedIn: 'root',
})
export class AdminCatalogService extends BaseService {
  private readonly screen = CATALOG_CONSTANTS;

  constructor(
    protected store: Store<any>,
    protected rest: RestService,
    protected message: VonMessageService
  ) {
    super();
  }

  getCatalogResult = (): Observable<AdminCatalogModel[]> =>
    this.store.select('admin', 'catalog', 'result');

  readCatalogs = (): Observable<any> =>
    this.rest
      .get<AdminCatalogModel[]>({
        url: `${environment.endpoints.admin}/catalog`,
      })
      .pipe(
        tap((catalogs) =>
          this.store.dispatch(
            adminCatalogActions.addResultAction({ result: catalogs })
          )
        )
      );
}
